import { useEffect, useState } from "react";
import { Copy } from "lucide-react";

import { cn, getText } from "shared/lib";

import { Button } from "shared/components";

interface CopyLinkButtonProps {
  className?: string;
  link: string;
  buttonText?: string;
}

export function CopyLinkButton({
  className,
  link,
  buttonText = getText("Copy public share link"),
}: CopyLinkButtonProps) {
  const [text, setText] = useState(buttonText);

  useEffect(() => {
    let timerId: any;

    if (text === "Copied!") {
      timerId = setTimeout(() => {
        setText(buttonText);
      }, 2000); // 2 seconds
    }

    return () => clearTimeout(timerId);
  }, [buttonText, text]);

  return (
    <Button
      className={cn("flex h-auto gap-1 p-0 underline print:hidden", className)}
      onClick={() => {
        setText("Copied!");
        navigator.clipboard.writeText(link);
      }}
      variant="link"
    >
      <Copy className="text-textLink hover:text-textLinkHover h-4 w-4" />
      {text}
    </Button>
  );
}
